import React, { useState, useEffect, useRef } from 'react';
import { ECommerceActions } from '../../../../Services/_actions/ECommerce/ecommerce.action';
import { useRecoilValue } from 'recoil';
import { botFlowDataAtom, flowValidationAtom } from '../../../../Services/_states';
import { Typography } from '@mui/material';
import { FlowBuilderActions } from '../../../../Services/_actions';
import RenderTextArea from './RenderTextArea.tsx';

interface SuggetionObj { label: string, value: string };

const CatalogNode = ({ data }) => {
  const actions = FlowBuilderActions();
  const flowValidationObj = useRecoilValue(flowValidationAtom);
  const botFlowData: any = useRecoilValue(botFlowDataAtom);
  const [catalog, setCatalog] = useState([]);
  const [bodyText, setBodyText] = useState(data?.body || '');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState < string[] > (['']);
  const [filteredSuggestions, setFilteredSuggestions] = useState < string[] > ([]);
  const [cursorPosition, setCursorPosition] = useState < number | null > (null);

  console.log(data, "12333333333333333333")

  const textareaRef = useRef < HTMLTextAreaElement > (null);

  useEffect(() => {
    if (data.body !== bodyText) {
      setBodyText(data.body || '');
    }
  }, [data.body]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 12}px`;
    }
  }, [bodyText]);

  const handleBodyChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setBodyText(value);

    const cursorPos = e.target.selectionStart;
    const textBeforeCursor = value.slice(0, cursorPos);

    // Detect `{{@` pattern
    const match = textBeforeCursor.match(/{{@(\w*)$/);
    if (match) {
      // const query = match[1]; // Get the text after `{{@`
      // setFilteredSuggestions(suggestions.filter((s) =>s.label.toLowerCase().includes(query.toLowerCase())));
      setShowSuggestions(true);
      setCursorPosition(cursorPos);
    } else {
      setShowSuggestions(false);
    }

    // Update `params` by finding all valid `{{label}}` entries in the text
    const matches = value.match(/{{(.*?)}}/g); // Match all `{{label}}`
    const labelsInBody = matches
      ? matches.map((match) => match.replace(/{{|}}/g, ""))
      : [];

    // Categorize params by `paramType`
    const categorizedParams = {
      global: [],
      result: [],
      webform: [],
    };

    data.parentResults.forEach((result: SuggetionObj) => {
      if (labelsInBody.includes(result.label)) {
        if (result.paramType === "global") {
          categorizedParams.global.push(result.value);
        } else if (result.paramType === "result") {
          categorizedParams.result.push(result.value);
        } else if (result.paramType === "webform") {
          categorizedParams.webform.push(result.value);
        }
      }
    });

    // Update parent data
    data.onChange(data.id, { body: value, params: categorizedParams });

    // Adjust the textarea height to fit content
    // if (textareaRef.current) {
    //   textareaRef.current.style.height = "auto"; // Reset height
    //   textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 12
    //     }px`; // Set height to content
    // }
  };



  const handleSuggestionClick = (suggestion: SuggetionObj) => {
    if (cursorPosition !== null) {
      const textBeforeCursor = bodyText.slice(0, cursorPosition);
      const textAfterCursor = bodyText.slice(cursorPosition);
      const updatedText =
        textBeforeCursor.replace(/{{@\w*$/, `{{${suggestion.label}}}`) +
        textAfterCursor;

      setBodyText(updatedText);
      setShowSuggestions(false);

      // Initialize parameters if not present
      const updatedParams = {
        global: data.params?.global || [],
        result: data.params?.result || [],
        webform: data.params?.webform || [],
      };

      // Add the value to the correct array based on paramType
      if (suggestion.paramType === "global") {
        updatedParams.global = [...updatedParams.global, suggestion.value];
      } else if (suggestion.paramType === "result") {
        updatedParams.result = [...updatedParams.result, suggestion.value];
      } else if (suggestion.paramType === "webform") {
        updatedParams.webform = [...updatedParams.webform, suggestion.value];
      }

      // Update parent data
      data.onChange(data.id, { body: updatedText, params: updatedParams });

      // Move cursor to the end of the inserted suggestion
      // setTimeout(() => {
      //   textareaRef.current?.setSelectionRange(
      //     updatedText.length,
      //     updatedText.length
      //   );
      // }, 0);
    }
  };
  const getCatalogList = async () => {
    if (!botFlowData?.phone_number_id) return;
    const res = await actions.getBotBuilderCatalogList(botFlowData?.phone_number_id);
    if (res && res.data) {
      setCatalog(res.data);
      data.onChange(data.id, { catalog: res?.data[0] || {} });
    }
  };

  const onSelectCatalogue = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCatalog = catalog.find((item) => item.id === e.target.value);
    data.onChange(data.id, { catalog: selectedCatalog });
  };

  useEffect(() => {
    getCatalogList();
  }, [botFlowData]);

  return (
    <div>
      <label>Catalog:</label>
      <select
        value={data?.catalog?.id || ''}
        onChange={onSelectCatalogue}
        style={{
          width: '100%',
          marginBottom: 10,
          padding: 5,
          border: '1px solid #ccc',
          borderRadius: 4,
          background: '#f5f5f5',
        }}
        disabled
      >
        <option value="">Select Catalog</option>
        {catalog.length > 0 ? (
          catalog.map((item: any) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))
        ) : (
          <option value="">No catalogs available</option>
        )}
      </select>

      {/* <label>Body:</label>
      <div style={{ position: 'relative' }}>
        <textarea
          ref={textareaRef}
          value={bodyText}
          onChange={handleBodyChange}
          placeholder="Enter text"
          maxLength={4096}
          style={{
            width: '100%',
            height: 'auto',
            padding: '5px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            background: '#f5f5f5',
            overflow: 'hidden',
            resize: 'none',
          }}

          // style={{
          //   width: '100%',
          //   height: '120px',
          //   padding: '5px',
          //   border: '1px solid #ccc',
          //   borderRadius: '4px',
          //   background: '#f5f5f5',
          // }}
        />
        <span
          style={{
            position: 'absolute',
            right: '10px',
            bottom: '10px',
            fontSize: '12px',
            color: bodyText.length === 4096 ? 'red' : '#888',
          }}
        >
          {`${bodyText.length}/4096`}
        </span>
      </div>
      {flowValidationObj[data?.id]?.body && (
        <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
          {flowValidationObj[data?.id]?.body}
        </Typography>
      )} */}

      <RenderTextArea
        data={data}
      />
      {flowValidationObj[data?.id]?.body && (
        <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
          {flowValidationObj[data?.id]?.body}
        </Typography>
      )}


      <label>Footer:</label>
      <div style={{ position: 'relative' }}>
        <input
          type="text"
          value={data.footer || ''}
          onChange={(e) => {
            const newFooter = e.target.value.slice(0, 60);
            data.onChange(data.id, { footer: newFooter });
          }}
          placeholder="Enter Footer Text"
          style={{
            width: '100%',
            padding: '5px',
            paddingRight: '50px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            background: '#f5f5f5',
          }}
        />
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: '12px',
            color: data.footer?.length === 60 ? 'red' : '#888',
          }}
        >
          {`${(data.footer || '').length}/60`}
        </span>
      </div>
      {flowValidationObj[data?.id]?.footer && (
        <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
          {flowValidationObj[data?.id]?.footer}
        </Typography>
      )}
    </div>
  );
};

export default CatalogNode;